import { forwardRef } from "react";

/**
 * Focused list of form errors linking to each field (Design Specification Sections 4.3, 10.6, 15.1 SC 3.3.1).
 * Shown above a form after a failed client-side validation submit; the caller focuses the returned ref.
 * `errors` is an array of { id, label } where `id` is the invalid field's DOM id and `label` is a short field
 * name (not the full inline error sentence — deliberately, so this list never duplicates text already shown,
 * word for word, beside the field).
 */
const ErrorSummary = forwardRef(function ErrorSummary({ errors, heading = "Please fix the following before continuing:" }, ref) {
  if (!errors || errors.length === 0) return null;
  return (
    <div
      ref={ref}
      role="alert"
      tabIndex={-1}
      className="border-2 border-[#B91C1C] bg-[#FEF2F2] rounded-xl p-4"
      data-testid="error-summary"
    >
      <p className="font-semibold text-[#B91C1C] mb-2">{heading}</p>
      <ul className="list-disc pl-5 space-y-1">
        {errors.map((e) => (
          <li key={e.id}>
            <a href={`#${e.id}`} className="underline text-[#B91C1C]" data-testid={`error-summary-link-${e.id}`}>
              {e.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
});

export default ErrorSummary;
